import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',

      gridGap: '1rem',
    },

    root: {
      border: '1px solid #D2D2D2',
      borderRadius: 6,
      padding: theme.spacing(2, 1.5, 1),
      flex: 1,

      '& > header': {
        marginBottom: theme.spacing(1),

        '& > h3': {
          fontSize: '1.6rem',
        },
      },

      '& ul': {
        margin: 0,
        padding: 0,

        ' & li + li': {
          marginTop: '1rem',
        },
      },
    },
    dateLabel: {
      fontSize: '1.2rem',
      fontWeight: 600,
    },
    dateContainer: {
      display: 'flex',
      gap: '1.2rem',

      width: '100%',

      '& > .MuiTextField-root': {
        width: '100%',
        margin: 0,
      },
    },
    buttonContainer: {
      display: 'flex',
      gap: '1.2rem',

      '& button': {
        width: '100%',
        height: '3.6rem',
        margin: 0,

        gap: '1rem',
      },
    },
  }),
)
